import { Box, Button, Heading, Link } from "@chakra-ui/react";
import Item from "antd/lib/list/Item";
import { useQuery } from "react-query";
import Section from "../../Component/Layout/Section";
import { getPost } from "../../service";
import { PostBasicStyle } from "../Board/View/style";
import { BannerContentsStyle } from "./style";

type Props = {
  params: any;
};

const Banner = ({ params  }: Props) => {

  const { isLoading, error, data } = useQuery('getPage', () => getPost(params.banner_id));
  
  return (
    !isLoading && !error && data && (
    <>
    <Section pt={40} pb={40}>
      <Heading size="4xl" pb="10" >{data.title}</Heading>
      <PostBasicStyle dangerouslySetInnerHTML={ {__html: data.content} } />
      <Box pt={8} pb={4} textAlign="center" >
        <Button size="lg" colorScheme="dgr">
          <Link href={data.meta.mainbanner_url} target="_blank">
            {data.meta.mainbanner_buttontext}
          </Link>
        </Button>
      </Box>
    </Section>
    </>
    )
  );
};

export default Banner;
